import pdf from '../assets/images/icon-pdf.svg';
import circleTick from '../assets/images/icon-circle_tick.svg';
import creditcardbenefits from '../assets/images/creditcardbenefits.svg';
import creditcardbenefits1 from '../assets/images/creditcardbenefits-1.svg';
import creditcardbenefits2 from '../assets/images/creditcardbenefits-2.svg';
import creditcardbenefits3 from '../assets/images/creditcardbenefits-3.svg';
import creditcardbenefits4 from '../assets/images/creditcardbenefits-4.svg';
import creditcardbenefits5 from '../assets/images/creditcardbenefits-5.svg';
import creditcardbenefits6 from '../assets/images/creditcardbenefits-6.svg';
import percentage from '../assets/images/icon-percentage.svg';
import grid from '../assets/images/icon-grid.svg';
import list from '../assets/images/icon-list.svg';
import documentDownload from '../assets/images/icon-file-download.svg';
import chevronDown from '../assets/images/icon-chevron-down.svg';
import chevronDownBlue from '../assets/images/icon-chevron-down_blue.svg';
import chevronDownThick from '../assets/images/icon-chevron-down_thick.svg';
import chevronUpThick from '../assets/images/icon-chevron-up_thick.svg';
import circleCheck from '../assets/images/icon-circle_tick2.svg';
import crossCircle from '../assets/images/icon-cross-circle_bold.svg';

export default {
  pdf,
  circleTick,
  creditcardbenefits,
  creditcardbenefits1,
  creditcardbenefits2,
  creditcardbenefits3,
  creditcardbenefits4,
  creditcardbenefits5,
  creditcardbenefits6,
  percentage,
  grid,
  list,
  documentDownload,
  chevronDown,
  chevronDownBlue,
  chevronDownThick,
  chevronUpThick,
  circleCheck,
  crossCircle,
};
